// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__6W3P8","rootSuccess":"CompleteLink_rootSuccess__2ni3j","rootFailure":"CompleteLink_rootFailure__13ZOH","isDisabled":"CompleteLink_isDisabled__3-auB"};